import { Model, Account } from './typings.d'
import { requestErrorHandler } from '-/services'
import { Dispatch } from '-/store/index'
import { setAuthority } from '-/utils/authority'
import { reloadAuthorized } from '-/utils/Authorized'
import { convertGetUserInfoReturnDataToUser } from '-/utils/adapter'
import { getV1UserMe, putV1UserCpUpdateProfileById } from '-/apis'

const initState = {
  current: null,
}

const user: Model = {
  state: initState,
  reducers: {
    setAccountInfo(state, info) {
      return {
        ...state,
        current: {
          ...info,
        },
      }
    },
    updateAccountInfo(state, info) {
      return {
        ...state,
        current: {
          ...(state.current as Account),
          ...info,
        },
      }
    },
    resetState(state) {
      return {
        ...state,
        current: null,
      }
    },
    setPhoneOfSelfAccount(state, payload) {
      return {
        ...state,
        current: { ...((state.current as unknown) as Account), phone: payload },
      }
    },
  },
  effects: (dispatch: Dispatch) => ({
    async getAccountInfo() {
      try {
        const { data } = await getV1UserMe()
        // 适配数据
        const accountInfo = convertGetUserInfoReturnDataToUser(data)

        // dispatch.account.setAccountInfo(accountInfo)
        dispatch.account.updateLocalAccountInfo(accountInfo)

        if (accountInfo.locked === 2) {
          dispatch.auth.logout('1')
        }
      } catch (err) {
        requestErrorHandler(err)
      }
    },
    async updateLocalAccountInfo(info) {
      dispatch.account.setAccountInfo(info)

      // TODO: 重构变成单点维护
      if (info.permissionData) {
        setAuthority(info.permissionData)

        reloadAuthorized()
      }
    },
    async updateSelfAccountInfo(info) {
      const { id, ...params } = info
      try {
        await putV1UserCpUpdateProfileById(id, { ...params })
        dispatch.account.updateAccountInfo(info)
        reloadAuthorized()
        return Promise.resolve()
      } catch (error) {
        requestErrorHandler(error)
        return Promise.reject()
      }
    },
  }),
}

export default user
